import Sticker from 'static/sticker.png';
import Image from './styled';

export default () => (
  <Image src={Sticker} alt="Sticker" />
);
